import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { MessageSquare, Mail } from 'lucide-react';
import SmsCampaigns from './SmsCampaigns';
import EmailCampaigns from './EmailCampaigns';
import { useEvent } from '../context/EventContext';

const Campaigns = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedEvent } = useEvent();

  // Determine initial tab from URL hash, default to SMS
  const getInitialTab = () => {
    if (location.hash === '#email') return 'email';
    return 'sms';
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  // Update URL hash when tab changes
  useEffect(() => {
    navigate(`#${activeTab}`, { replace: true });
  }, [activeTab, navigate]);

  // Sync state if URL changes externally
  useEffect(() => {
    setActiveTab(getInitialTab());
  }, [location.hash]);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto space-y-6">
        
        {/* Top Level Tabs */}
        <div className="bg-white p-2 rounded-xl shadow-sm border border-gray-200 sticky top-[73px] z-10 mx-6 mt-6">
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={() => setActiveTab('sms')}
              className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'sms'
                  ? 'bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 shadow-sm border border-teal-100'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 border border-transparent'
              }`}
            >
              <MessageSquare className="w-5 h-5" />
              SMS Campaigns
            </button>
            <button
              onClick={() => setActiveTab('email')}
              className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'email'
                  ? 'bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 shadow-sm border border-teal-100'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 border border-transparent'
              }`}
            >
              <Mail className="w-5 h-5" />
              Email Campaigns
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'sms' && <SmsCampaigns />}
          {activeTab === 'email' && <EmailCampaigns />}
        </div>
        
      </div>
    </Layout>
  );
};

export default Campaigns;
